import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";
import { Link } from "react-router-dom";
import AppRoutes from "../config/AppRoutes";
import { styled } from "@mui/material";
import calculateLtv from "../util/calculateLtv";

const LtvError = styled("span")({
  color: "orange",
  fontSize: "18px",
  fontWeight: "bold",
  width: "100%",
  maxWidth: "55vw",
  textAlign: "center",
  paddingBottom: "20px",
  "& a": {
    color: "orange",
  },
});

const VALUES = ["Yes", "No", "Not Sure"];

const getDownPaymentPage = (lookingTo) => {
  switch (lookingTo) {
    case "Purchase":
      return AppRoutes.PURCHASE_IRQ_DOWN_PAYMENT_PAGE;
    case "Build":
      return AppRoutes.BUILD_IRQ_DOWN_PAYMENT_PAGE;
    default:
      return AppRoutes.REFINANCE_IRQ_EXISTING_BALANCE_PAGE;
  }
};

class IrqWaiveEscrowView extends Component {
  constructor(props) {
    super(props);
    this.isWaivingEscrowDisallowed = calculateLtv(props.data) > 80;
    this.handleChoiceMade = this.handleChoiceMade.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.data.hasWaivedEscrow === "undefined") {
      this.props.customFormEdit("hasWaivedEscrow", "No");
    }
    if (
      this.isWaivingEscrowDisallowed &&
      ["Yes", "Not Sure"].includes(this.props.data.hasWaivedEscrow)
    ) {
      this.props.navigationContext.setNextButtonDisabled(true);
    }
  }

  handleChoiceMade(index) {
    if (this.isWaivingEscrowDisallowed) {
      this.props.customFormEdit("hasWaivedEscrow", "No");
    } else {
      this.props.customFormEdit("hasWaivedEscrow", VALUES[index]);
    }
    this.props.navigationContext.goNext(
      this.props.navigationsAway.Primary,
      true
    );
    this.props.navigationContext.setNextButtonDisabled(false);
  }

  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          {this.isWaivingEscrowDisallowed && (
            <LtvError>
              Escrow cannot be waived when the{" "}
              {this.props.lookingTo === "Refinance"
                ? "existing balance is more than 80% of the property value"
                : this.props.lookingTo === "RefinanceAndCashOut"
                ? "existing balance plus cash out amount is more than 80% of the property value"
                : "down payment is less than 20%"}
              .{" "}
              <Link
                to={getDownPaymentPage(this.props.lookingTo)}
                onClick={() =>
                  this.props.navigationContext.setNextButtonDisabled(false)
                }
              >
                Click here
              </Link>{" "}
              to edit your{" "}
              {["Refinance", "RefinanceAndCashOut"].includes(
                this.props.lookingTo
              )
                ? "existing balance"
                : "down payment"}
              , or continue without waiving escrow by clicking "Acknowledge".
            </LtvError>
          )}
          {this.isWaivingEscrowDisallowed ? (
            <IrqChoiceButtons
              content={{ firstChoice: "Acknowledge" }}
              value={this.props.data.hasWaivedEscrow}
              values={["Acknowledge"]}
              onChoiceMade={this.handleChoiceMade}
            />
          ) : (
            <IrqChoiceButtons
              content={this.props.content}
              value={this.props.data.hasWaivedEscrow}
              values={VALUES}
              onChoiceMade={this.handleChoiceMade}
            />
          )}
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqWaiveEscrowView));
